// extracted by mini-css-extract-plugin
export default {"-large":"ZD_kHoY7LuYRfB6sFDwk","btn":"JFaaUbbE3ZtvRxHCtNTT","hasHover":"mRBVNv0ukRQmj7sdWCtA","dateText":"AenQVtV0jH5GY2pM7xNr"};